import { TableActions, TableActionTypes, TableState } from "store/types/table";

const initialState: TableState<any> = {
    selectedRowKeys: {},
    sortOrderMap: {},
    sortedData: []
}

const tableReducer = (state = initialState, action: TableActions<any>): TableState<any> => {
    switch (action.type) {
        case TableActionTypes.SET_SORTED_DATA:
            return {
                ...state,
                sortedData: action.payload
            }
        case TableActionTypes.SET_SELECTED_ROW_KEYS:
            return {
                ...state,
                selectedRowKeys: {...action.payload},
            }
        case TableActionTypes.SET_SORT_ORDER_MAP:
            return {
                ...state,
                sortOrderMap: action.payload,
            }
        default:
            return state;
    }
}

export default tableReducer;